<template>
  <div class="docker">
    <div
      v-for="(item, index) in dockerListRef"
      :key="index"
      class="docker__item"
      :class="{
        'docker__item--active': index === currentIndex,
        'docker__item--raised': item.raised,
      }"
      @click="handleDockItemClick(item)"
    >
      <template v-if="item.to">
        <router-link :to="item.to">
          <template v-if="item.raised">
            <div class="docker__raised">
              <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
                <circle cx="9" cy="20" r="1.6" fill="currentColor" />
                <circle cx="17" cy="20" r="1.6" fill="currentColor" />
                <path d="M3 4h2l2.4 11h10.2l1.9-8H6.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </template>
          <template v-else>
            <div :class="item.icon" v-if="item.iconfont" />
            <img
              v-else
              class="docker__item__img"
              :src="index === currentIndex ? item.icon[0] : item.icon[1]"
            />
          </template>
          <div class="docker__title">{{ item.text }}</div>
        </router-link>
      </template>
      <template v-else>
        <div :class="item.icon" v-if="item.iconfont" />
        <img
          v-else
          class="docker__item__img"
          :src="index === currentIndex ? item.icon[0] : item.icon[1]"
        />
        <div class="docker__title">{{ item.text }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { onActivated, onDeactivated } from "@vue/runtime-core";

const useDockerListEffect = (t) => {
  const dockerList = [
    {
      icon: ["iconfont", "icon-shouye"],
      text: t("app.docker.website"),
      iconfont: true,
      // to: { name: "Website" },
    },
    {
      icon: [
        require("@/assets/website_do.png"),
        require("@/assets/website_undo.png"),
      ],
      text: t("app.docker.main"),
      iconfont: false,
      to: { name: "Dealer" },
    },
    // {
    //   // 中间凸起的购物入口 → 下单流程
    //   text: "选购",
    //   raised: true,
    //   to: { name: "CShop" },
    // },
    {
      icon: ["iconfont", "icon-fangan"],
      text: t("app.docker.scheme"),
      iconfont: true,
      to: { name: "Scheme" },
    },
    {
      icon: ["iconfont", "icon-wode"],
      text: t("app.docker.mine"),
      iconfont: true,
      to: { name: "Mine" },
    },
  ];
  return { dockerList };
};

export default {
  name: "Docker",
  props: ["currentIndex"],
  setup(props) {
    const { t } = useI18n(); // 获取 t 方法
    const { dockerList } = useDockerListEffect(t);
    const dockerListRef = ref(dockerList);

    onActivated(() => {
      const { dockerList } = useDockerListEffect(t);
      dockerListRef.value = dockerList;
    });

    const handleDockItemClick = (item) => {
      if (!item.to) {
        // 跳转到官网
        window.location.replace("/");
      }
    };

    return { dockerListRef, handleDockItemClick };
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/viriables.scss";
.docker {
  box-sizing: border-box;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
  width: 100%;
  height: 0.49rem;
  padding: 0 0.18rem;
  border-top: 0.01rem solid $content-bgColor;
  background: $bgColor;
  display: flex;

  &__item {
    flex: 1;
    text-align: center;
    a {
      color: $content-fontcolor;
      text-decoration: none;
    }
    .iconfont {
      margin: 0.07rem 0 0.02rem 0;
      font-size: 0.18rem;
    }
    &__img {
      margin: 0.07rem 0 0.02rem 0;
      width: 0.18rem;
      // height: 0.18rem;
    }
    &--active {
      a {
        color: $themeColor;
      }
    }
    &--raised {
      a {
        color: $themeColor;
      }
    }
  }

  &__raised {
    width: 0.52rem;
    height: 0.52rem;
    border-radius: 50%;
    background: linear-gradient(135deg, #026b32 0%, #009343 100%);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: -0.34rem auto 0.04rem;
    border: 0.03rem solid #ffffff;
    box-shadow: 0 0.04rem 0.12rem rgba(0, 147, 67, 0.32);
  }

  &__title {
    font-size: 0.2rem;
    transform: scale(0.5, 0.5);
    transform-origin: center top;
  }
}
</style>
